import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { currentStateList } from '@fttb/common/constants';
import { setPopupVisibility, submitCallbackRequest } from '@fttb/common/store';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { captureException } from '@fttb/common/components';
import { FTTB_PAGE_PREFIX } from "../../constants";
import { getActiveCtn } from "../../shared/selectors";
export var setCurrentPopupState = createAction("".concat(FTTB_PAGE_PREFIX, "::setCurrentPopupState"));
export var setIsLoadingTariffButton = createAction("".concat(FTTB_PAGE_PREFIX, "::setIsLoading"));
export var fetchCallbackRequest = createAsyncThunk('fetchCallbackRequest', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inacId, _ref) {
    var dispatch, getState, state, activeCtn, result, isCaptchaError, isSucceeded, shouldShowCaptcha;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, getState = _ref.getState;
          state = getState();
          activeCtn = getActiveCtn(state);
          dispatch(setIsLoadingTariffButton({
            inacId: inacId,
            isLoad: true
          }));
          _context.prev = 4;
          _context.next = 7;
          return submitCallbackRequest({
            caseTitle: 'support',
            phoneNumber: "+7".concat(activeCtn)
          });
        case 7:
          result = _context.sent;
          isCaptchaError = result.isCaptchaError, isSucceeded = result.isSucceeded, shouldShowCaptcha = result.shouldShowCaptcha;
          if (isSucceeded) {
            dispatch(setCurrentPopupState(currentStateList.success));
          } else if (isCaptchaError || shouldShowCaptcha) {
            dispatch(setCurrentPopupState(currentStateList.captcha));
          } else {
            dispatch(setCurrentPopupState(currentStateList.fail));
          }
          dispatch(setPopupVisibility());
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](4);
          captureException(_context.t0);
          dispatch(setCurrentPopupState(currentStateList.fail));
        case 17:
          _context.prev = 17;
          dispatch(setIsLoadingTariffButton({
            inacId: inacId,
            isLoad: false
          }));
          return _context.finish(17);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 13, 17, 20]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());